<template>
  <div class="box">
    <div class="box-item">
      <img :src="$cdnPath.img + 'Activity/act215/bg1.png'"/>
      <div class="box-btn" @click="copy(1)" :class="'to-copy'" :data-clipboard-text="copyTxt"></div>
      <div class="box-btn2" @click="copy(1)" :class="'to-copy'" :data-clipboard-text="copyTxt"></div>
    </div>
  </div>
</template>

<script>
  import Clipboard from 'clipboard'
  export default {
    name: "index",
    data() {
      return {
        fooId:11010, activityId:215,copyTxt:'seven_meow'
      };
    },
    mounted(){

    },
    methods:{
      goWx(){
        this.$SPM(this.fooId,this.activityId, `.2`);
        this.$yymd.yy2c('{"a":100,"v":1,"p":{"type":"2","url":"weixin://"}}');
      },
      copy(p){
        this.$SPM(this.fooId,this.activityId, `.1`);
        var clipboard = new Clipboard('.to-copy');
        clipboard.on('success', e => {
          clipboard.destroy()
          if (p){
            this.$dialog.confirm({
              title:'微信号已复制',
              mes: '打开微信，添加完好友，即可领取500金币哟~',
              opts: [
                {
                  txt: '打开微信',
                  color: true,
                  callback: () => {
                    this.goWx();
                  }
                }
              ]
            });
          } else {
            this.goWx();
          }
          // 释放内存
        })
        clipboard.on('error', e => {
          // 不支持复制
          console.log('该浏览器不支持自动复制', e)
          // 释放内存
          clipboard.destroy()
        });
      }
    }
  }
</script>

<style rel="stylesheet/less" lang="less" scoped>
.box {
  position: relative;
  img {
    width:100%;height:auto;
  }
  &-btn {
    position: absolute;
    width:28%; height:7.7%;left:64%;top:76%;
  }
  &-btn2 {
    position: absolute;
    width:96%; height:9%;left:2%;top:88%;
  }
}
</style>